module.exports = __webpack_public_path__ + "img/wechatpay.acf65832.png";